import { render, staticRenderFns } from "./shipping-taxes.vue?vue&type=template&id=711d9706&scoped=true&"
import script from "./shipping-taxes.vue?vue&type=script&lang=js&"
export * from "./shipping-taxes.vue?vue&type=script&lang=js&"
import style0 from "./shipping-taxes.vue?vue&type=style&index=0&id=711d9706&lang=scss&scoped=true&"
import style1 from "./shipping-taxes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d9706",
  null
  
)

export default component.exports